<!-- Формульный ввод габаритов груза заказа с автоподсчётом объёма одного места. -->
<template>
  <BaseInlineFormula
    :fields="4"
    :separators="['×', '×', '=']"
    :sizes="['sm', 'sm', 'sm', 'lg']"
  >
    <template #field-0>
      <base-label
        :required="required"
        :filled="Boolean(item.height_m)"
        info-key="cargo.dimensions"
      >
        Высота, м
      </base-label>
      <base-input
        :model-value="item.height_m"
        type="big_number"
        min="0"
        step="0.001"
        placeholder="0.000"
        :invalid="Boolean(errors[errorKey('height_m')])"
        @update:modelValue="updateField('height_m', $event)"
      />
      <span
        v-if="errors[errorKey('height_m')]"
        class="error-message"
      >
        Укажите высоту
      </span>
    </template>

    <template #field-1>
      <base-label
        :required="required"
        :filled="Boolean(item.width_m)"
        info-key="cargo.dimensions"
      >
        Ширина, м
      </base-label>
      <base-input
        :model-value="item.width_m"
        type="big_number"
        min="0"
        step="0.001"
        placeholder="0.000"
        :invalid="Boolean(errors[errorKey('width_m')])"
        @update:modelValue="updateField('width_m', $event)"
      />
      <span
        v-if="errors[errorKey('width_m')]"
        class="error-message"
      >
        Укажите ширину
      </span>
    </template>

    <template #field-2>
      <base-label
        :required="required"
        :filled="Boolean(item.length_m)"
        info-key="cargo.dimensions"
      >
        Длина, м
      </base-label>
      <base-input
        :model-value="item.length_m"
        type="big_number"
        min="0"
        step="0.001"
        placeholder="0.000"
        :invalid="Boolean(errors[errorKey('length_m')])"
        @update:modelValue="updateField('length_m', $event)"
      />
      <span
        v-if="errors[errorKey('length_m')]"
        class="error-message"
      >
        Укажите длину
      </span>
    </template>

    <template #field-3>
      <base-label
        :required="required"
        :filled="Boolean(item.volume_m3)"
        info-key="cargo.volume"
      >
        Объём места, м³
      </base-label>
      <base-input
        :model-value="item.volume_m3"
        type="big_number"
        min="0"
        step="0.001"
        placeholder="0.000"
        :invalid="Boolean(errors[errorKey('volume_m3')])"
        @update:modelValue="updateField('volume_m3', $event)"
      />
      <span
        v-if="errors[errorKey('volume_m3')]"
        class="error-message"
      >
        Укажите объём
      </span>
    </template>
  </BaseInlineFormula>
</template>

<script>
import {
  syncCargoModelDimensionsFromManualVolume,
  syncCargoModelVolumeFromDimensions,
} from "@/utils/cargoCalculatorUtils";

export default {
  name: "OrderCargoDimensionsFormula",

  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update-field"],

  methods: {
    updateField(field, value) {
      const nextItem = { ...this.item, [field]: value };

      if (this.syncDimensionsFromManualVolume(field, nextItem)) return;
      if (this.syncVolumeFromDimensions(field, nextItem)) return;

      this.$emit("update-field", {
        index: this.index,
        values: { [field]: value },
      });
    },

    errorKey(field) {
      return `cargoItems.${this.index}.${field}`;
    },

    syncVolumeFromDimensions(field, nextItem) {
      const draftItem = { ...nextItem };
      if (!syncCargoModelVolumeFromDimensions(draftItem, field)) return false;

      this.$emit("update-field", {
        index: this.index,
        values: {
          [field]: nextItem[field],
          volume_m3: draftItem.volume_m3,
          auto_calculated_volume_m3: draftItem.auto_calculated_volume_m3,
        },
      });
      return true;
    },

    syncDimensionsFromManualVolume(field, nextItem) {
      const draftItem = { ...nextItem };
      if (!syncCargoModelDimensionsFromManualVolume(draftItem, field)) return false;

      this.$emit("update-field", {
        index: this.index,
        values: {
          volume_m3: nextItem.volume_m3,
          height_m: draftItem.height_m,
          width_m: draftItem.width_m,
          length_m: draftItem.length_m,
          auto_calculated_volume_m3: draftItem.auto_calculated_volume_m3,
        },
      });
      return true;
    },
  },
};
</script>
